import security from './3d_modeling.png'
import brainstorm from './brainsstorm.png'
import cross_platform from './responsive_design.png'
import low_code from './software_design.png'
import mobile_apps from './mobile_apps.png'
import testing from './testing.png'

export default {
  security,
  brainstorm,
  cross_platform,
  low_code,
  mobile_apps,
  testing
}



// WEBPACK FOOTER //
// ./src/assets/icons/exports.js